import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import FormFields from '../../../../../themes/admin/Fields/FormFields';
import useFinanceProductOptions from '../../shared/useFinanceProductOptions';
import YesNoField from './YesNoField';

const colSpan = { lg: 8, xs: 24 };

const BalloonGfv = ({ disabled = false }: { disabled?: boolean }) => {
    const { t } = useTranslation(['financeProductDetails']);

    const { balloonInstalmentOptions } = useFinanceProductOptions();

    return (
        <Row gutter={[16, 16]}>
            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.residualViewable', { returnObjects: true })}
                    disabled={disabled}
                    name="balloonGfv.isViewable"
                />
            </Col>

            <Col {...colSpan}>
                <YesNoField
                    {...t('financeProductDetails:fields.residualEditable', { returnObjects: true })}
                    disabled={disabled}
                    name="balloonGfv.isEditable"
                />
            </Col>
            <Col {...colSpan}>
                <FormFields.SelectField
                    {...t('financeProductDetails:fields.settlementInstalment', { returnObjects: true })}
                    disabled={disabled}
                    name="balloonGfv.settlementInstalmentOn"
                    options={balloonInstalmentOptions}
                    required
                    showSearch
                />
            </Col>
        </Row>
    );
};

export default BalloonGfv;
